import Reveal from '@/components/feature/Reveal';

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = 'left',
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <Reveal className={isCenter ? 'text-center' : ''}>
      <span
        className={`inline-flex items-center gap-2 text-xs md:text-sm tracking-[0.18em] font-medium ${
          light ? 'text-primary-300' : 'text-primary-700'
        }`}
      >
        <span className={`w-6 h-px ${light ? 'bg-primary-400' : 'bg-primary-500'}`}></span>
        {kicker}
      </span>
      <h2
        className={`mt-3 font-heading font-bold text-2xl md:text-3xl lg:text-4xl leading-snug ${
          light ? 'text-background-50' : 'text-foreground-950'
        } ${isCenter ? 'mx-auto max-w-3xl' : ''}`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            light ? 'text-background-300' : 'text-foreground-600'
          } ${isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`}
        >
          {desc}
        </p>
      )}
    </Reveal>
  );
}